<template>
  <CouponPopupNotLogged
    :dataSource="configData"
    :show="show"
    @close="closePopup"
    :closeOnClickOverlay="false"
    :page="trackPage"
    buttonValue="banner"
    v-if="show"
  />
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import { getByActivityId } from '@/api/activity/coupon'
  import CouponPopupNotLogged from '@/components/CouponPopupNotLogged'
  import { isObj } from '@/utils/tool'

  // 优惠券提示
  export default {
    name: 'banner-notice',
    components: {
      CouponPopupNotLogged,
    },
    props: {
      activeBanner: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        show: false,
        configData: {},
      }
    },
    computed: {
      ...mapState(['gameName', 'region', 'userInfo']),
      ...mapGetters(['trackPage']),
    },
    watch: {},
    mounted() {},
    methods: {
      getCouponData() {
        // 获取指定活动的弹窗数据
        const { activityId } = this.activeBanner
        if (!activityId) return
        getByActivityId({ activityId }).then((response) => {
          this.handleCouponDatas(response)
        })
      },
      handleCouponDatas(response) {
        if (Array.isArray(response)) {
          // 返回值为数组 不合法
          return
        }
        this.configData = response || {}
        if (isObj(this.configData) && Object.keys(this.configData).length) {
          this.show = true
        }
      },
      closePopup() {
        this.show = false
      },
      jumpCoupon() {
        this.$router_push({
          path: `/coupon`,
        })
      },
    },
  }
</script>
